import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

import "./assets/css/library/bootstrap.min.css";
import "./assets/css/main.css";

import NotFoundPage from "./pages/404.js";
import Home from "./pages/Home";
import Auth from "./pages/Auth";
import CompleteUserProfile from "./pages/Auth/CompleteUserProfile";
import Profile from "./pages/Profile/ProfileInformation";
import UpdateProfile from "./pages/Profile/UpdateProfile";
import LoadPost from "./pages/LoadPost";
import Modal from "./components/Modal";
import RequireAuth from "./components/RequireAuth";
import BasicSetup from "./components/BasicSetup";
import Chat from "./pages/Chat";
import Transaction from "./pages/Transaction/Transaction";
import Preloader from "./components/Preloader";
import Notification from "./pages/Notification/Notification";
import SearchCarrier from "./pages/Search/SearchCarrier";
import SearchLoadPost from "./pages/Search/SearchLoadPost";
import Order from "./pages/Order";
import Carrier from "./pages/Carrier";
import Withdraw from "./pages/Withdraw";
import Payment from "./pages/Payment";
import Favorite from "./pages/Favorite";
import Contact from "./pages/Contact";
import CarrierRealTimeLocation from "./components/CarrierRealTimeLocation";
import PaypalWeb from "./PaypalWeb";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import UserReviews from "./pages/UserReviews";
import Wallet from "./pages/Wallet";
import AccountInformation from "./pages/Profile/AccountInformation";
import Performance from "./pages/Carrier/Performance";
import CarrierPendingOffers from "./pages/Carrier/Monitor";
import UserProfileInformation from "./pages/Profile/UserProfileInformation";

function App() {
  const [clint_width, setClint_width] = useState(window.innerWidth);

  const detectSize = () => {
    setClint_width(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [clint_width]);

  return (
    // Bydefault all componet would contains header and footer but we can disable it
    // by passing isHeaderRequired and isFoterRequired props to RequireAuth component

    <Provider store={store}>
      <CarrierRealTimeLocation />
      <BrowserRouter>
        <div
          style={{
            maxWidth: clint_width,
            overflowX: "hidden",
          }}
        >
          <BasicSetup />
          <Preloader />
          <div className="mobile-bg"></div>{" "}
          {/* background effect for mobile menu */}
          <Routes>
            <Route path="/auth/*" element={<Auth />} />
            <Route
              path="/chat/*"
              element={
                <RequireAuth isFoterRequired={false}>
                  <Chat />
                </RequireAuth>
              }
            />
            <Route
              path="/profile-information"
              element={
                <RequireAuth>
                  <Profile />
                </RequireAuth>
              }
            />
            <Route
              path="/account-information"
              element={
                <RequireAuth>
                  <AccountInformation />
                </RequireAuth>
              }
            />
            <Route
              path="/:userID/user-profile-information"
              element={
                <RequireAuth>
                  <UserProfileInformation />
                </RequireAuth>
              }
            />
            <Route
              path="/complete-user-profile"
              element={
                <RequireAuth>
                  <CompleteUserProfile />
                </RequireAuth>
              }
            />
            <Route
              path="/update-profile/*"
              element={
                <RequireAuth>
                  <UpdateProfile />
                </RequireAuth>
              }
            />
            <Route
              path="/load-post/*"
              element={
                <RequireAuth>
                  <LoadPost />
                </RequireAuth>
              }
            />
            <Route
              path="/transaction"
              element={
                <RequireAuth>
                  <Transaction />
                </RequireAuth>
              }
            />
            <Route
              path="/notification"
              element={
                <RequireAuth>
                  <Notification />
                </RequireAuth>
              }
            />
            <Route
              path="/search-carrier"
              element={
                <RequireAuth>
                  <SearchCarrier />
                </RequireAuth>
              }
            />
            <Route
              path="/search-load-post"
              element={
                <RequireAuth>
                  <SearchLoadPost />
                </RequireAuth>
              }
            />
            <Route
              path="/order/*"
              element={
                <RequireAuth>
                  <Order />
                </RequireAuth>
              }
            />
            <Route
              path="/carrier/*"
              element={
                <RequireAuth>
                  <Carrier />
                </RequireAuth>
              }
            />
            <Route
              path="/withdraw/*"
              element={
                <RequireAuth>
                  <Withdraw />
                </RequireAuth>
              }
            />
            <Route
              path="/payment/:paymentRequestId/*"
              element={
                <RequireAuth>
                  <Payment />
                </RequireAuth>
              }
            />
            <Route
              path="/favorite/"
              element={
                <RequireAuth>
                  <Favorite />
                </RequireAuth>
              }
            />
            
            <Route
              path="/wallet/"
              element={
                <RequireAuth>
                  <Wallet />
                </RequireAuth>
              }
            />
            <Route
              path="/performance/"
              element={
                <RequireAuth>
                  <Performance />
                </RequireAuth>
              }
            />
            <Route
              path="/pending-offers/"
              element={
                <RequireAuth>
                  <CarrierPendingOffers />
                </RequireAuth>
              }
            />

            <Route
              path="/contact/"
              element={
                <RequireAuth>
                  <Contact />
                </RequireAuth>
              }
            />
            <Route
              path="/paypal-payment/:paymentRequestId/:authToken/*"
              element={<PaypalWeb />}
            />
            {/* /****************************************** This 2 path should be
          always on the bottom *********************************************/}
            <Route path="/" element={<Home />} />
            <Route path="/privacy-Policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="*" element={<NotFoundPage />} />
            {/* /******************************************
             *********************************************/}
          </Routes>
        </div>
      </BrowserRouter>

      <Modal />
    </Provider>
  );
}

export default App;
